import React, { useMemo } from 'react';
import DashboardLayout from '../DashboardLayout/DashboardLayout';
import type { NavItem } from '../DashboardLayout/DashboardLayout';

// Istanza di DashboardLayout per l'area superadmin — riusa le stesse pagine
// dell'area admin (Overview, Users, UserDetail, Orders, Courses,
// Communications) montate sotto /superadmin/*, dato che il superadmin ha
// controllo totale (superset delle capacità admin) e non ha bisogno di
// pagine duplicate. Le sole differenze operative (es. gestire l'account
// admin) sono già coperte da AdminUsers/AdminUserDetail tramite la
// gerarchia dei ruoli (vedi RoleGuard::canManageUser).
//
// "Comunicazioni" è uno strumento per INVIARE notifiche agli utenti, non una
// casella di ricezione: niente badge finto, non c'è un "non letto" reale.
const SuperAdminLayout: React.FC = () => {
  const navItems: NavItem[] = useMemo(
    () => [
      {
        path: '/superadmin',
        icon: 'bi-speedometer2',
        label: 'Panoramica',
        end: true,
      },
      { path: '/superadmin/utenti', icon: 'bi-people', label: 'Utenti' },
      {
        path: '/superadmin/corsi',
        icon: 'bi-collection-play',
        label: 'Corsi',
      },
      { path: '/superadmin/ordini', icon: 'bi-receipt', label: 'Ordini' },
      {
        path: '/superadmin/comunicazioni',
        icon: 'bi-megaphone',
        label: 'Comunicazioni',
        labelShort: 'Comms',
      },
    ],
    []
  );

  return (
    <DashboardLayout
      navItems={navItems}
      areaLabel="Super Admin"
      notifPath="/superadmin/comunicazioni"
    />
  );
};

export default SuperAdminLayout;
